// UsersPagination.tsx
import React from "react";
import { Pagination } from "react-bootstrap";

type Props = {
  total: number;
  page: number;
  pageSize: number;
  onPageChange: (p: number) => void;
};

export default function UsersPagination({ total, page, pageSize, onPageChange }: Props) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  // Nothing to paginate when everything fits on a single page — hide the control.
  if (totalPages <= 1) return null;

  const items: number[] = [];
  const start = Math.max(1, page - 2);
  const end = Math.min(totalPages, page + 2);
  for (let i = start; i <= end; i++) items.push(i);

  return (
    <div className="d-flex justify-content-center w-100">
      <Pagination className="w-100 py-4 bg-white ">
        <Pagination.Prev onClick={() => onPageChange(Math.max(1, page - 1))} disabled={page === 1} />
        {start > 1 && <Pagination.Ellipsis disabled />}
        {items.map((i) => (
          <Pagination.Item key={i} active={i === page} onClick={() => onPageChange(i)}>
            {i}
          </Pagination.Item>
        ))}
        {end < totalPages && <Pagination.Ellipsis disabled />}
        <Pagination.Next onClick={() => onPageChange(Math.min(totalPages, page + 1))} disabled={page === totalPages} />
      </Pagination>
    </div>
  );
}
